export default __webpack_public_path__ + "static/media/location_preview_bam_pow.a13859b9.svg";